export function loginEvent() {
  return {
    event: 'login',
    method: 'Ecommerce',
  };
}

export function signUpEvent() {
  return {
    'event': 'sign_up',
    'method': 'Ecommerce',
  };
}
